import { BehaviorSubject } from 'rxjs';
import { CLASS_TRANSFORMER_GLOBAL_CONFIG, CLASS_VALIDATOR_GLOBAL_CONFIG } from '@core/shared/model';
import { getGlobal } from './get-global.util';
const globalDynamicFormBuilderOptions = 'globalDynamicFormBuilderOptions';
export function getGlobalDynamicFormBuilderOptionsSubject() {
  const global = getGlobal();
  if (!global[globalDynamicFormBuilderOptions]) {
    global[globalDynamicFormBuilderOptions] = new BehaviorSubject({});
  }
  return global[globalDynamicFormBuilderOptions];
}
export function getGlobalDynamicFormBuilderOptions() {
  return getGlobalDynamicFormBuilderOptionsSubject().value || {};
}
export function setGlobalDynamicFormBuilderOptions(opts) {
  getGlobalDynamicFormBuilderOptionsSubject().next(opts);
}
// patch our custom classTransformer/classValidator base config into dynamic-form-builder global config
const dfbOpts = getGlobalDynamicFormBuilderOptions();
setGlobalDynamicFormBuilderOptions({
  ...dfbOpts,
  classTransformOptions: CLASS_TRANSFORMER_GLOBAL_CONFIG,
  classValidatorOptions: CLASS_VALIDATOR_GLOBAL_CONFIG
});
export function getMergedClassTransformOptions(dynamicFormBuilderOptions) {
  const classTransformOptions = {
    ...getGlobalDynamicFormBuilderOptions().classTransformOptions,
    ...dynamicFormBuilderOptions.classTransformOptions
  };
  return classTransformOptions;
}